var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 127,
    viewBox: "0 0 162 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4987 61.9606C7.05331 61.9606 1 81.0453 1 81.0453V127H161V56.5176C149 56.5176 154.534 99 144.491 99C134.448 99 136.924 7.4626 123.992 8.68898C111.06 9.91535 116.013 49.6142 103.494 49.6142C90.9742 49.6142 94.5512 1 82.9948 1C71.4385 1 76.9415 43.4409 62.4961 43.4409C48.0507 43.4409 52.7283 93.309 41.9974 93.309C31.2666 93.309 35.9441 61.9606 21.4987 61.9606Z",
    fill: "url(#paint0_linear_1_984)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 80.1657C1 80.1657 7.05331 61.2907 21.4987 61.2907C35.9441 61.2907 31.2666 92.2946 41.9974 92.2946C52.7283 92.2946 48.0507 42.9746 62.4961 42.9746C76.9415 42.9746 71.4385 1 82.9948 1C94.5512 1 90.9742 49.0799 103.494 49.0799C116.013 49.0799 111.06 9.81738 123.992 8.60448C136.924 7.39158 134.448 97.9231 144.491 97.9231C154.534 97.9231 149 55.9076 161 55.9076",
    stroke: "#FF7D38",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_984",
    x1: 81,
    y1: 1,
    x2: 81,
    y2: 127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FF8",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A6FF8",
    stopOpacity: 0.02
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphs);
export default __webpack_public_path__ + "static/media/Graphs.6b38a5856ec5cf9ee5a3146e59f105ca.svg";
export { ForwardRef as ReactComponent };